import { AdvancedSettingsService } from "./AdvancedSettingsService";
import { CompanyService } from "./CompanyService";
import { LocationNumbersService } from "./LocationNumbersService"
import { MoveNumbersService } from "./MoveNumbersService";
import { TwilioAccountService } from "./TwilioAccountService";
import { UserService } from "./UserService";
import axios, { AxiosRequestConfig } from "axios";
import config from "../config";
import firebase from 'firebase/compat/app'

const getHeader = () => {
  return {
    channel: 'APP',
    source: 'WEB_USER',
    version: '2021-07-28'
  }
}


export const requests = (host?:string) => {
  const baseUrl = host || config.MARKETPLACE_REST_API_URL

  const axiosInstance = axios.create(
    {
      baseURL:baseUrl,
      headers: getHeader(),
    }
  )

  axiosInstance.interceptors.request.use(async (requestConfig: AxiosRequestConfig) => {
    try {
        requestConfig.headers['token-id'] = await firebase
          .auth()
          .currentUser?.getIdToken()
    } catch (e) {
      console.error(`Error in getting the current user token: ${JSON.stringify(e)}`)
    }
    return requestConfig
  })

  return axiosInstance
}

export {
  AdvancedSettingsService,
  CompanyService,
  LocationNumbersService,
  MoveNumbersService,
  TwilioAccountService,
  UserService,
}
